import React, { useEffect, useState } from 'react';
import { Box, Typography, Switch, Paper } from '@mui/material';
import api from '../../services/api.js';
import AdminPageHeader from '../../next/AdminPageHeader.jsx';

const FeatureFlags = () => {
  const [flags, setFlags] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadFlags = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/feature-flags');
      setFlags(data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadFlags(); }, []);

  const handleToggle = async (flag) => {
    try {
      const { data } = await api.put(`/feature-flags/${flag._id}`, {
        enabled: !flag.enabled,
      });
      setFlags((prev) => prev.map((f) => (f._id === data._id ? data : f)));
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) return <Box><Typography>טוען...</Typography></Box>;

  return (
    <Box>
      <AdminPageHeader
        title="דגלי פיצ'ר"
        sub="הפעלה וכיבוי של יכולות במערכת — השינוי חל מיד"
        legacy={(
          <Typography variant="h5" fontWeight={700} gutterBottom>
            דגלי פיצ'ר
          </Typography>
        )}
      />

      {flags.map((flag) => (
        <Paper key={flag._id} sx={{ p: 2, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography fontWeight={600}>{flag.key}</Typography>
            <Typography variant="body2" color="text.secondary">{flag.description}</Typography>
          </Box>
          <Switch
            checked={flag.enabled}
            onChange={() => handleToggle(flag)}
            color="primary"
          />
        </Paper>
      ))}
    </Box>
  );
};

export default FeatureFlags;
